import { type RadioGroupProps, RadioGroup, get } from '@mfw/components';
import { type FieldError, Controller } from 'react-hook-form';

export interface FormRadioGroupProps extends Omit<RadioGroupProps, 'errors'> {
  name: string;
}

export const FormRadioGroup = ({
  defaultValue,
  name,
  ...otherProps
}: FormRadioGroupProps) => {
  return (
    <Controller
      render={({ field, formState: { defaultValues, errors, isLoading } }) => {
        const formDefaultValue = get(defaultValues, name) ?? undefined;
        const error = get<FieldError>(errors, name) ?? undefined;
        return (
          <RadioGroup
            defaultValue={defaultValue ?? formDefaultValue}
            errors={error?.message}
            {...field}
            {...otherProps}
            loading={otherProps?.loading || isLoading}
          />
        );
      }}
      name={name}
    />
  );
};
